import React, { FC } from 'react';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import Help from '../presentational/Help';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';

const HelpContainer: FC = () => {
    return (
        <PageContainer className="help-container">
            <SectionTitle title="Help" />
            <Help />
        </PageContainer>
    );
};

export default HelpContainer;
